export enum TextoMetodopago {
  PSE = 'Tarjeta Débito (PSE)',
  TARJETA_CREDITO = 'Tarjeta de Crédito',
  PSE_TARJETA_CREDITO = 'Tarjeta de Crédito / Débito / PSE',
  NO_DISPONIBLE = 'Medios de pago no disponibles',
}
